export const SuccessTickIcon = ({ width, height }: any) => {
  return (
    <svg
      width={width ?? 80}
      height={height ?? 80}
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M34.1433 54.38L20 40.2333L24.7133 35.52L34.1433 44.9466L52.9967 26.09L57.7133 30.8066L34.1433 54.38Z"
        fill="#4DCA00"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.33398 40C3.33398 19.75 19.7507 3.33331 40.0007 3.33331C60.2507 3.33331 76.6673 19.75 76.6673 40C76.6673 60.25 60.2507 76.6666 40.0007 76.6666C19.7507 76.6666 3.33398 60.25 3.33398 40ZM40.0007 70C36.061 70 32.1599 69.224 28.5201 67.7164C24.8804 66.2087 21.5732 63.9989 18.7874 61.2132C16.0017 58.4274 13.7919 55.1203 12.2843 51.4805C10.7766 47.8407 10.0007 43.9396 10.0007 40C10.0007 36.0603 10.7766 32.1592 12.2843 28.5195C13.7919 24.8797 16.0017 21.5725 18.7874 18.7868C21.5732 16.001 24.8804 13.7912 28.5201 12.2836C32.1599 10.776 36.061 9.99998 40.0007 9.99998C47.9571 9.99998 55.5878 13.1607 61.2139 18.7868C66.8399 24.4129 70.0007 32.0435 70.0007 40C70.0007 47.9565 66.8399 55.5871 61.2139 61.2132C55.5878 66.8393 47.9571 70 40.0007 70Z"
        fill="#4DCA00"
      />
    </svg>
  );
};

export default SuccessTickIcon;
